var inherit = require("../../general.js").inherit;
var SortedMap = require("../../collections/sortedMap.js");
var HashSet = require("../../collections/hashSet.js");
var ObservableSet = require("./../observableSet.js");
var TreeEvent = require('./treeEvent.js');

var ObservableTreeSet = function(treeNode, name, owner, validator){
    ObservableSet.call(this, validator);
    this._treeNode = treeNode;
    this._name = name;
    this._owner = owner || false;
    this.handlers.bubble = null;
};
inherit(ObservableTreeSet, ObservableSet);
ObservableTreeSet.prototype.getName = function(){ return this._name; };
ObservableTreeSet.prototype.getTreeNode = function(){ return this._treeNode; };
ObservableTreeSet.prototype.isOwner = function(){ return this._owner; };

ObservableTreeSet.prototype.onBubble = function(key, handler, priority){
    console.assert(key != null && handler && typeof handler == "function", "Scheduling handler expects a valid key + handler function");
    if(!this.handlers.bubble) this.handlers.bubble = new SortedMap();
    this.handlers.bubble.put(key, handler, priority || 0);
};

ObservableTreeSet.prototype.replaceWithoutTriggers = function(newVal, oldVal){
    this.remove(oldVal, true);
    this.add(newVal, true);
}

ObservableTreeSet.prototype.add = function(val, noObservations){
    var self = this;
    if (!this.nonPersistent && this._treeNode.root && this._treeNode.root.isLocked && this._treeNode.root.isLocked(true)) return;

    if (!this.contains(val)){
        var validated = !this.validator || this.validator(val);
        if(validated) {
            HashSet.prototype.add.call(this, val);

            if (this._owner){
                if (val && val.isObservableTreeNode) val._addTreeNodeTo([this, val]);
            } else {
                if (val && val.isObservableTreeNode) val.referrers.add([this, val]);
            }

            if(!noObservations){    
                var event = new TreeEvent("add", this, val, val);
                if (this._treeNode.root && this._treeNode.root.logEvent) this._treeNode.root.logEvent(event);

                this.handlers.add && this.handlers.add.forEach(function(k, handler){
                    handler.call(self, val, val);
                });

                event.trigger();
            }
        } else {
            if(noObservations){
                this.handlers.addFail && this.handlers.addFail.forEach(function(k, handler){
                    handler.call(self, val, val);
                });
            }
        }
        return validated;
    } else return true;
};

ObservableTreeSet.prototype.remove = function(val) {
    var self = this;
    if (!this.nonPersistent && this._treeNode.root && this._treeNode.root.isLocked && this._treeNode.root.isLocked(true)) return;

    if (this.contains(val)) {
        HashSet.prototype.remove.call(this, val);

        if (this._owner){
            if (val && val.isObservableTreeNode) val._removeTreeNode();
        } else {
            if (val && val.isObservableTreeNode) val.referrers.remove([this, val]);
        }

        var event = new TreeEvent("remove", this, val, undefined, val);
        if (this._treeNode.root && this._treeNode.root.logEvent) this._treeNode.root.logEvent(event);

        this.handlers.remove && this.handlers.remove.forEach(function(k, handler){
            handler.call(self, val, val);
        });

        event.trigger();

        return val;
    }
};

module.exports = ObservableTreeSet;